async function diasHastaEfecto(fechaEfecto){

    var moment = require('moment');

    var fechaEfectoBuena = moment(new Date(), "YYYY-MM-DD");

    var fechaActual = moment(new Date(), "YYYY-MM-DD");
    
    let dias = fechaEfectoBuena.diff(fechaActual, 'days');

    return dias;

}




async function quitarElementoMatrix(matriz, valor){

    var matrizNueva = [];
 
    for (let indice in matriz)
    {

        let elemento = matriz[indice];
        
        if (elemento != valor)
        {
            matrizNueva.push(elemento);

        }


    }

    return matrizNueva;

}


async function EncontrarPrecio(Precios, Producto){

    for (let indice in Precios)
    {

        let codigo = Precios[indice]["codigo"];


        if (codigo == Producto)
        {

            if (Precios[indice]["precios"])
            {

                let retorno = Precios[indice]["precios"];
                return retorno;

            } else {

                let retorno = {};
                return retorno;

            }


        }


    }

    let retorno = {};
    return retorno;

}


async function EncontrarPreciosAddons(Precios, Addones){


    var PreciosAddons = [];
    var Addons = Addones;

    if (Addons.length > 0)
    {

        for (let index in Addons)
        {

            let addon = Addons[index];
            
            let precioAddon = await EncontrarPrecio(Precios, addon);

            if (precioAddon["Mensual"] > 0)
            {

                PreciosAddons.push(precioAddon);

            }
            

        }


    } 

    return PreciosAddons;

}


async function EncontrarNombreProducto(Precios, Producto){

    for (let indice in Precios)
    {

        let codigo = Precios[indice]["codigo"];


        if (codigo == Producto)
        {

            if (Precios[indice]["name"])
            {

                let retorno = Precios[indice]["name"];
                return retorno;

            } else {

                let retorno = "";
                return retorno;

            }


        }


    }

    let retorno = "";
    return retorno;

}

async function sumarExtensiones(Extensiones, PeriodoSeleccionado)
{

    var PrecioFinal = 0;

    for (let index in Extensiones)
    {

        let extension = Extensiones[index];
        if (extension[PeriodoSeleccionado] > 0)
        {

            let precio = extension[PeriodoSeleccionado];
            var PrecioFinal = (PrecioFinal+precio);

        }
        
    }


    var PrecioFinal = Math.round(PrecioFinal*100)/100;

    return PrecioFinal;

}

async function AddonEstaSeleccionado(Extensiones, Codigo)
{

    for (let index in Extensiones)
    {

        let extension = Extensiones[index];
        if (extension == Codigo)
        {

            return true;

        }
        
    }

    return false;

}


async function ExtensionesSinGrupo(Extensiones, Options){

    var ExtensionesSinGrupo = Extensiones;

    for (let index in Options)
    {

        let option = Options[index];
        let codigo = option.code;

        let EsteEstaSeleccionado = await AddonEstaSeleccionado(Extensiones, codigo);

        if (EsteEstaSeleccionado == true)
        {

            var ExtensionesSinGrupo = await quitarElementoMatrix(ExtensionesSinGrupo, codigo);

        }
        

    }

    return ExtensionesSinGrupo;

}

async function GrupodeExtensionesSeleccionadas(Extensiones, Options){

    var Seleccionados = 0;

    for (let index in Options)
    {

        let option = Options[index];
        let codigo = option.code;

        let seleccionado = await AddonEstaSeleccionado(Extensiones, codigo);

        if (seleccionado == true)
        {

            var Seleccionados = (Seleccionados+1);

        }
        

    }


    if (Seleccionados > 0)
    {

        return true;

    } else {

        return false;

    }


}

async function sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}


async function ActualizarTablasExtension(options, Precios, ProductoSeleccionado, AddonsSeleccionados, PeriodoSeleccionado, method){

    var OpcionesDadas = [];
  

    let NumerodeProductos = (AddonsSeleccionados.length+1);
    let NProductosEnMatriz = (NumerodeProductos-1);



    //Calcular el Precio Mostrado
    let extensiones = await EncontrarPreciosAddons(Precios[NProductosEnMatriz], AddonsSeleccionados);
    let precioAddons = await sumarExtensiones(extensiones, PeriodoSeleccionado);
    let preciosSeleccionado = await EncontrarPrecio(Precios[NProductosEnMatriz], ProductoSeleccionado);
    let PrecioActual = preciosSeleccionado[PeriodoSeleccionado];
    let PrecioTotalActual = (PrecioActual+precioAddons);

    //console.log("Precio Actual");
    //console.log(PrecioTotalActual);

    //Calculo el Precio Futuro de los Addons que estan fuera del bloque
    let ExtensionesFueraGrupo = await ExtensionesSinGrupo(AddonsSeleccionados, options); 
    //Aqui meto +1 en periodos para calcular el precio de los addons de fuera del bloque
    let opcionesExtensionesFuera = await EncontrarPreciosAddons(Precios[NumerodeProductos], ExtensionesFueraGrupo);
    let precioAddonsFuera = await sumarExtensiones(opcionesExtensionesFuera, PeriodoSeleccionado);


    //Calcular el Precio del Producto Principal en el Futuro
    let NumerodeProductosFuturo = (ExtensionesFueraGrupo.length+1);
    let preciosSeleccionadoFuturo = await EncontrarPrecio(Precios[NumerodeProductosFuturo], ProductoSeleccionado);
    let PrecioFuturo = preciosSeleccionadoFuturo[PeriodoSeleccionado];
    let PrecioFuturoTotalSinContarAlternativas = (PrecioFuturo+precioAddonsFuera);

    //console.log("Precio Futuro");
    //console.log(PrecioFuturoTotalSinContarAlternativas);


    for (let indOp in options)
    { 
  
        var opcion = options[indOp];
  
        if (preciosSeleccionado[PeriodoSeleccionado] > 0)
        {
  
          let preciosAlternativa = await EncontrarPrecio(Precios[NumerodeProductosFuturo], opcion.code);
  
          if (preciosAlternativa[PeriodoSeleccionado] > 0)
          {
  
              if (method == "sum")
              {
  
                //Calculamos los precios de las extensiones 
  
                let PrecioConOpcion = (preciosAlternativa[PeriodoSeleccionado]+PrecioFuturoTotalSinContarAlternativas);

                //console.log("Precio con Opcion");

                //console.log(PrecioConOpcion);

  
                let DiferenciaPonerOpcion = (PrecioConOpcion-PrecioTotalActual);


                //console.log(DiferenciaPonerOpcion);
  
                let Diferencia = Math.round((DiferenciaPonerOpcion)*100)/100;
  
  
                opcion["price"] = Diferencia;
  
                OpcionesDadas.push(opcion);

                
  
              }
  
  
          }
  
        }
      } 
  
      var OpcionesDadas =  await sortByKey(OpcionesDadas, "price");
      return OpcionesDadas;
  
}

async function ActualizarTablas(options, Precios, ProductoSeleccionado, AddonsSeleccionados, PeriodoSeleccionado, method){

  var OpcionesDadas = [];

  let NumeroProductos = await NumeroProductosSeleccionados(AddonsSeleccionados, ProductoSeleccionado);

  let NProductosEnMatriz = (NumeroProductos-1);

  for (let indOp in options)
  { 

      var opcion = options[indOp];
      let preciosSeleccionado = await EncontrarPrecio(Precios[NProductosEnMatriz], ProductoSeleccionado);

      if (preciosSeleccionado[PeriodoSeleccionado] > 0)
      {

        let preciosAlternativa = await EncontrarPrecio(Precios[NumeroProductos], opcion.code);

        if (preciosAlternativa[PeriodoSeleccionado] > 0)
        {

            if (method == "sum")
            {

              //Calculamos los precios de las extensiones
              let extensiones = await EncontrarPreciosAddons(Precios[NumeroProductos], AddonsSeleccionados);
              let precioAddons = await sumarExtensiones(extensiones, PeriodoSeleccionado);


              let PrecioActual = preciosSeleccionado[PeriodoSeleccionado];


              //Precio Mostrado
              let PrecioTotalActual = (PrecioActual+precioAddons);


              //Precio Quitando Addons del Grupo
              let ExtensionesFueraGrupo = await ExtensionesSinGrupo(AddonsSeleccionados, options); //Es este
              let precioAddonsFuera = await sumarExtensiones(ExtensionesFueraGrupo, PeriodoSeleccionado);

            
              //Aqui buscamos el producto actual con el precio de sumarle un producto mas
              let PreciosDescuentoProductoActual = await EncontrarPrecio(Precios[NumeroProductos], ProductoSeleccionado);
              let precioActualConDescuento = PreciosDescuentoProductoActual[PeriodoSeleccionado];

              
              //Precio Sin Addons de Grupo
              let PrecioTotalFueraGrupo = (precioActualConDescuento+precioAddonsFuera);

              let PrecioConOpcion = (preciosAlternativa[PeriodoSeleccionado]+PrecioTotalFueraGrupo);


              let DiferenciaPonerOpcion = (PrecioConOpcion-PrecioTotalActual);


              let Diferencia = Math.round((DiferenciaPonerOpcion)*100)/100;


              opcion["price"] = Diferencia;

              OpcionesDadas.push(opcion);

            }


        }

      }
    } 

    var OpcionesDadas =  await sortByKey(OpcionesDadas, "price");
    return OpcionesDadas;

}



async function ActualizarTablasProducts(options, Precios, ProductoSeleccionado, AddonsSeleccionados, PeriodoSeleccionado, method){

    var Opciones = [];

    let NumeroProductos = await NumeroProductosSeleccionados(AddonsSeleccionados, ProductoSeleccionado);
    let NProductosEnMatriz = (NumeroProductos-1);


    for (let indOp in options)
    {

        var opcion = options[indOp];
        let preciosSeleccionado = await EncontrarPrecio(Precios[NProductosEnMatriz], ProductoSeleccionado);

        if (preciosSeleccionado[PeriodoSeleccionado] > 0)
        {

          let preciosAlternativa = await EncontrarPrecio(Precios[NProductosEnMatriz], opcion.code);

          if (preciosAlternativa[PeriodoSeleccionado] > 0)
          {


              if (method == "diference")
              {

                let Diferencia = Math.round((preciosAlternativa[PeriodoSeleccionado]-preciosSeleccionado[PeriodoSeleccionado])*100)/100;
                opcion["price"] = Diferencia;
                Opciones.push(opcion);

              }


          }

        }


    }

    let OpcionesOrdenadas = await sortByKey(Opciones, "price");

    return OpcionesOrdenadas;


}


async function NumeroProductosSeleccionados(Extensiones, Producto){


    var indice = 0;

    if (Producto != "")
    {
        var indice = (indice+1);

    }

    var contarExtensiones = Extensiones.length;
    var NumeroProductos = (indice+contarExtensiones);
    return NumeroProductos;


}



async function VerDatosPresupuesto(url, idPresupuesto){

    var axios = require("axios");

    try {

        let resultados = {idPresupuesto : idPresupuesto};

        let Datos = await axios(
            {
                method: 'post',
                url: url,
                data: resultados,
                config: { headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json' 
                  }}
            }
        );

        return Datos.data;
        
    } catch (error) {

        let retorno = {"status" : "KO", "message" : error};
        return retorno;
        
    }

}


async function SaveTracking(url, idPresupuesto, precio, periodo, addons, producto){

    var axios = require("axios");

    try {

        let resultados = {

            "idPresupuesto" : idPresupuesto,
            "precio" : precio,
            "periodo" : periodo,
            "addons" : addons,
            "producto" : producto
        
        };

        console.log(resultados);


        let Datos = await axios(
            {
                method: 'post',
                url: url,
                data: resultados,
                config: { headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json' 
                  }}
            }
        );

        return Datos.data;
        
    } catch (error) {

        let retorno = {"status" : "KO", "message" : error};
        return retorno;
        
    }

}


async function SearchFaqs(code, MatrixProducts){

    for (let indexProduct in MatrixProducts)
    {

        let product = MatrixProducts[indexProduct];

        if (product.cod == code) {


            return product.faqcode;

        }

    }


    let primero = MatrixProducts[0];
    return primero.faqcode;

}





exports.EncontrarPrecio = EncontrarPrecio;
exports.sortByKey = sortByKey;
exports.EncontrarNombreProducto = EncontrarNombreProducto;
exports.EncontrarPreciosAddons = EncontrarPreciosAddons;
exports.sumarExtensiones = sumarExtensiones;
exports.GrupodeExtensionesSeleccionadas = GrupodeExtensionesSeleccionadas;
exports.AddonEstaSeleccionado = AddonEstaSeleccionado;
exports.ExtensionesSinGrupo = ExtensionesSinGrupo;
exports.ActualizarTablas = ActualizarTablas;
exports.ActualizarTablasProducts = ActualizarTablasProducts;
exports.NumeroProductosSeleccionados = NumeroProductosSeleccionados;
exports.VerDatosPresupuesto = VerDatosPresupuesto;
exports.ActualizarTablasExtension = ActualizarTablasExtension;
exports.SearchFaqs = SearchFaqs;
exports.SaveTracking = SaveTracking;
exports.diasHastaEfecto = diasHastaEfecto;